module.exports = __webpack_public_path__ + "img/icon-mp_1.3f696050.png";